const warte = (ms) => new Promise(resolve => setTimeout(resolve, ms));

class GlobalAbholStandort extends HTMLElement {
    connectedCallback() {
        this.laufendeMatnrn = new Set();
        this.aufloesen();
        this.domUeberwachen();
    }

    aufloesen() {
        const offene = document.querySelectorAll("abhol-standort:not([changed='true'])");
        const matnummern = [...new Set([...offene].map(element => element.dataset.matnr).filter(Boolean))];
        matnummern.forEach(matnr => this.holeAbholaussagen(matnr));
    }

    async holeAbholaussagen(matnr) {
        if (this.laufendeMatnrn.has(matnr)) {
            return; // fuer diese Matnummer ist bereits ein Request unterwegs
        }
        this.laufendeMatnrn.add(matnr);
        try {
            const response = await this.fetchRetry(
                `/lieferaussage/api/abholaussage/artikel/${encodeURIComponent(matnr)}`, { method: "GET" }, 3, 2000);
            const { abholaussagen } = await response.json();
            this.verteile(matnr, abholaussagen);
        } catch (error) {
            console.error("Abholaussagen konnten nicht ermittelt werden:", error);
            this.zeigeFehler(matnr);
        } finally {
            this.laufendeMatnrn.delete(matnr);
        }
    }

    verteile(matnr, abholaussagen) {
        (abholaussagen ?? []).forEach(({ filialId, abholaussage, abholstatus }) => {
            const element = this.findeStandort(matnr, filialId);
            if (!element) {
                return; // kein Standort-Element fuer diese Filiale -> ignorieren
            }
            element.setAttribute("data-abholaussage", abholaussage);
            element.setAttribute("data-abholstatus", abholstatus);
            element.setAttribute("changed", "true");
        });
    }

    zeigeFehler(matnr) {
        document.querySelectorAll(`abhol-standort[data-matnr="${CSS.escape(matnr)}"]:not([changed='true'])`)
            .forEach(element => {
                element.setAttribute("data-fehler", "true");
                element.setAttribute("changed", "true");
            });
    }

    findeStandort(matnr, filialId) {
        // bereits finalisierte Elemente (changed) nicht erneut ueberschreiben
        return document.querySelector(
            `abhol-standort[data-matnr="${CSS.escape(matnr)}"][data-filial-id="${CSS.escape(String(filialId))}"]:not([changed='true'])`);
    }

    domUeberwachen() {
        const observer = new MutationObserver(mutationsList => {
            const neueKnoten = mutationsList.some(mutation =>
                [...mutation.addedNodes].some(node =>
                    node.nodeType === Node.ELEMENT_NODE &&
                    (node.tagName === "ABHOL-STANDORT" || node.querySelector?.("abhol-standort:not([changed='true'])"))));
            if (neueKnoten) {
                this.aufloesen();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    /**
     * fetch mit Retry: Netzwerkfehler und 5xx werden bis zu n-mal wiederholt,
     * 4xx werden sofort als Fehler durchgereicht.
     */
    async fetchRetry(url, options, n, t = 1000) {
        for (let versuch = 1; versuch <= n; versuch++) {
            let response;
            try {
                response = await fetch(url, options);
            } catch (netzwerkFehler) {
                if (versuch === n) throw netzwerkFehler;
                await warte(t * 2 ** (versuch - 1)); // exponentieller Backoff
                continue;
            }
            if (response.ok) {
                return response;
            }
            if (response.status < 500 || versuch === n) {
                throw new Error(`Abholaussagen-Request fehlgeschlagen: ${response.status}`);
            }
            await warte(t * 2 ** (versuch - 1)); // exponentieller Backoff
        }
    }
}

if (!customElements.get("global-abhol-standort")) {
    customElements.define("global-abhol-standort", GlobalAbholStandort);
}

document.body.insertAdjacentHTML("beforeend", `<global-abhol-standort></global-abhol-standort>`);
